<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Duplicate Dollar Transaction</div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="duplicateDollarTxCount"
        >
          Transaction Count
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="duplicateDollarTrCount">#</span>
            <input
              aria-describedby="duplicateDollarTrCount"
              class="form-control"
              type="number"
              name="duplicateDollarTxCount"
              id="duplicateDollarTxCount"
              formControlName="duplicateDollarTxCount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.duplicateDollarTxCount.invalid &&
                  (fraudRiskFormControls.duplicateDollarTxCount.dirty ||
                    fraudRiskFormControls.duplicateDollarTxCount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.duplicateDollarTxCount.invalid &&
              (fraudRiskFormControls.duplicateDollarTxCount.dirty ||
                fraudRiskFormControls.duplicateDollarTxCount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.duplicateDollarTxCount.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.duplicateDollarTxCount.errors?.max"
            >
              Value is too high. Max is 9999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="duplicateDollarTxAmount"
        >
          Transaction Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="duplicateDollarTrAmount">$</span>
            <input
              aria-describedby="duplicateDollarTrAmount"
              class="form-control"
              type="number"
              name="duplicateDollarTxAmount"
              id="duplicateDollarTxAmount"
              formControlName="duplicateDollarTxAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.duplicateDollarTxAmount.invalid &&
                  (fraudRiskFormControls.duplicateDollarTxAmount.dirty ||
                    fraudRiskFormControls.duplicateDollarTxAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.duplicateDollarTxAmount.invalid &&
              (fraudRiskFormControls.duplicateDollarTxAmount.dirty ||
                fraudRiskFormControls.duplicateDollarTxAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.duplicateDollarTxAmount.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.duplicateDollarTxAmount.errors?.max"
            >
              Value is too high. Max is 99999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Excessive Volume Increase</div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="excessiveVolumeIncreasePercent1vs90"
        >
          Percentage - Daily vs. 90 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input
              class="form-control text-right"
              type="number"
              name="excessiveVolumeIncreasePercent1vs90"
              id="excessiveVolumeIncreasePercent1vs90"
              formControlName="excessiveVolumeIncreasePercent1vs90"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                      .touched)
              }"
            />
            <div class="input-group-prepend fixed3emwidth">
              <span class="input-group-text">%</span>
            </div>
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                .dirty ||
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs90.errors
                  ?.min
              "
            >
              Value cannot be less than 100.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evvDailyVs90DaysAmount"
        >
          Amount - Daily vs. 90 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dailyVs90DaysAmount">$</span>
            <input
              aria-describedby="dailyVs90DaysAmount"
              class="form-control"
              type="number"
              name="evvDailyVs90DaysAmount"
              id="evvDailyVs90DaysAmount"
              formControlName="excessiveVolumeIncreaseAmount1vs90"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90
                      .touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90.dirty ||
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90.errors
                  ?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs90.errors
                  ?.max
              "
            >
              Value is too high. Max is 999999999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evvDailyVs30DaysPercent"
        >
          Percentage - Daily vs. 30 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input
              class="form-control text-right"
              type="number"
              name="evvDailyVs30DaysPercent"
              id="evvDailyVs30DaysPercent"
              formControlName="excessiveVolumeIncreasePercent1vs30"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                      .touched)
              }"
            />
            <div class="input-group-prepend fixed3emwidth">
              <span class="input-group-text">%</span>
            </div>
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                .dirty ||
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs30.errors
                  ?.min
              "
            >
              Value cannot be less than 100.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evvDailyVs30DaysAmount"
        >
          Amount - Daily vs. 30 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dailyVs30DaysAmount">$</span>
            <input
              aria-describedby="dailyVs30DaysAmount"
              class="form-control"
              type="number"
              name="evvDailyVs30DaysAmount"
              id="evvDailyVs30DaysAmount"
              formControlName="excessiveVolumeIncreaseAmount1vs30"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30
                      .touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30.dirty ||
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30.errors
                  ?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs30.errors
                  ?.max
              "
            >
              Value is too high. Max is 999999999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evvDailyVs7DaysPercent"
        >
          Percentage - Daily vs. 7 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input
              class="form-control text-right"
              type="number"
              name="evvDailyVs7DaysPercent"
              id="evvDailyVs7DaysPercent"
              formControlName="excessiveVolumeIncreasePercent1vs7"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7
                      .touched)
              }"
            />
            <div class="input-group-prepend fixed3emwidth">
              <span class="input-group-text">%</span>
            </div>
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7.dirty ||
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreasePercent1vs7.errors
                  ?.min
              "
            >
              Value cannot be less than 100.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evvDailyVs7DaysAmount"
        >
          Amount - Daily vs. 7 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dailyVs7DaysAmount">$</span>
            <input
              class="form-control"
              type="number"
              name="evvDailyVs7DaysAmount"
              id="evvDailyVs7DaysAmount"
              formControlName="excessiveVolumeIncreaseAmount1vs7"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7
                      .touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7.invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7.dirty ||
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7.errors
                  ?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount1vs7.errors
                  ?.max
              "
            >
              Value is too high. Max is 999999999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evv7DayVs90DaysPercent"
        >
          Percentage - 7 Day vs. 90 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input
              class="form-control text-right"
              type="number"
              name="evv7DayVs90DaysPercent"
              id="evv7DayVs90DaysPercent"
              formControlName="excessiveVolumeIncreasePercent7vs90"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                      .touched)
              }"
            />
            <div class="input-group-prepend fixed3emwidth">
              <span class="input-group-text">%</span>
            </div>
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                .dirty ||
                fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreasePercent7vs90.errors
                  ?.min
              "
            >
              Value cannot be less than 100.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="evv7DayVs90DaysAmount"
        >
          Amount - 7 Day vs. 90 Day
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="day7Vs90DaysAmount">$</span>
            <input
              aria-describedby="day7Vs90DaysAmount"
              class="form-control"
              type="number"
              name="evv7DayVs90DaysAmount"
              id="evv7DayVs90DaysAmount"
              formControlName="excessiveVolumeIncreaseAmount7vs90"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90
                    .invalid &&
                  (fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90
                    .dirty ||
                    fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90
                      .touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90
                .invalid &&
              (fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90.dirty ||
                fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90.errors
                  ?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.excessiveVolumeIncreaseAmount7vs90.errors
                  ?.max
              "
            >
              Value is too high. Max is 999999999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Daily Unmatched Credits</div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="dailyUnmatchedCreditsCount"
        >
          Credits Count
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="creditsCount">#</span>
            <input
              aria-describedby="creditsCount"
              class="form-control"
              type="number"
              name="dailyUnmatchedCreditsCount"
              id="dailyUnmatchedCreditsCount"
              formControlName="dailyUnmatchedCreditsCount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.dailyUnmatchedCreditsCount.invalid &&
                  (fraudRiskFormControls.dailyUnmatchedCreditsCount.dirty ||
                    fraudRiskFormControls.dailyUnmatchedCreditsCount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.dailyUnmatchedCreditsCount.invalid &&
              (fraudRiskFormControls.dailyUnmatchedCreditsCount.dirty ||
                fraudRiskFormControls.dailyUnmatchedCreditsCount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.dailyUnmatchedCreditsCount.errors?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.dailyUnmatchedCreditsCount.errors?.max
              "
            >
              Value is too high. Max is 9999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="dailyUnmatchedCreditsAmount"
        >
          Credits Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="creditsAmount">$</span>
            <input
              aria-describedby="creditsAmount"
              class="form-control"
              type="number"
              name="dailyUnmatchedCreditsAmount"
              id="dailyUnmatchedCreditsAmount"
              formControlName="dailyUnmatchedCreditsAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.dailyUnmatchedCreditsAmount.invalid &&
                  (fraudRiskFormControls.dailyUnmatchedCreditsAmount.dirty ||
                    fraudRiskFormControls.dailyUnmatchedCreditsAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.dailyUnmatchedCreditsAmount.invalid &&
              (fraudRiskFormControls.dailyUnmatchedCreditsAmount.dirty ||
                fraudRiskFormControls.dailyUnmatchedCreditsAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.dailyUnmatchedCreditsAmount.errors?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.dailyUnmatchedCreditsAmount.errors?.max
              "
            >
              Value is too high. Max is 99999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Same Card Transaction</div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="sameCardTxCount"
        >
          Transaction Count
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="sameCardTrCount">#</span>
            <input
              aria-describedby="sameCardTrCount"
              class="form-control"
              type="number"
              name="sameCardTxCount"
              id="sameCardTxCount"
              formControlName="sameCardTxCount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.sameCardTxCount.invalid &&
                  (fraudRiskFormControls.sameCardTxCount.dirty ||
                    fraudRiskFormControls.sameCardTxCount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.sameCardTxCount.invalid &&
              (fraudRiskFormControls.sameCardTxCount.dirty ||
                fraudRiskFormControls.sameCardTxCount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.sameCardTxCount.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.sameCardTxCount.errors?.max"
            >
              Value is too high. Max is 99.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="sameCardTxAmount"
        >
          Transaction Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="sameCardTrAmount">$</span>
            <input
              aria-describedby="sameCardTrAmount"
              class="form-control"
              type="number"
              name="sameCardTxAmount"
              id="sameCardTxAmount"
              formControlName="sameCardTxAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.sameCardTxAmount.invalid &&
                  (fraudRiskFormControls.sameCardTxAmount.dirty ||
                    fraudRiskFormControls.sameCardTxAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.sameCardTxAmount.invalid &&
              (fraudRiskFormControls.sameCardTxAmount.dirty ||
                fraudRiskFormControls.sameCardTxAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.sameCardTxAmount.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.sameCardTxAmount.errors?.max"
            >
              Value is too high. Max is 99999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Total Daily Foreign Card</div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="totalDailyForeignCardCount"
        >
          Foreign Card Count
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="foreignCardCount">#</span>
            <input
              aria-describedby="foreignCardCount"
              class="form-control"
              type="number"
              name="totalDailyForeignCardCount"
              id="totalDailyForeignCardCount"
              formControlName="totalDailyForeignCardCount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.totalDailyForeignCardCount.invalid &&
                  (fraudRiskFormControls.totalDailyForeignCardCount.dirty ||
                    fraudRiskFormControls.totalDailyForeignCardCount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.totalDailyForeignCardCount.invalid &&
              (fraudRiskFormControls.totalDailyForeignCardCount.dirty ||
                fraudRiskFormControls.totalDailyForeignCardCount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.totalDailyForeignCardCount.errors?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.totalDailyForeignCardCount.errors?.max
              "
            >
              Value is too high. Max is 99.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="totalDailyForeignCardTxAmount"
        >
          Foreign Card Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="foreignCardTrAmount">$</span>
            <input
              aria-describedby="foreignCardTrAmount"
              class="form-control"
              type="number"
              name="totalDailyForeignCardTxAmount"
              id="totalDailyForeignCardTxAmount"
              formControlName="totalDailyForeignCardTxAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.totalDailyForeignCardTxAmount.invalid &&
                  (fraudRiskFormControls.totalDailyForeignCardTxAmount.dirty ||
                    fraudRiskFormControls.totalDailyForeignCardTxAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.totalDailyForeignCardTxAmount.invalid &&
              (fraudRiskFormControls.totalDailyForeignCardTxAmount.dirty ||
                fraudRiskFormControls.totalDailyForeignCardTxAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.totalDailyForeignCardTxAmount.errors?.min
              "
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="
                fraudRiskFormControls.totalDailyForeignCardTxAmount.errors?.max
              "
            >
              Value is too high. Max is 99999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation"></div>
      </legend>
    </div>
    <div class="col-md-8">
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="txLimitToAlert"
        >
          Transaction Limit to Alert
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="trLimitToAlert">$</span>
            <input
              aria-describedby="trLimitToAlert"
              class="form-control"
              type="number"
              name="txLimitToAlert"
              id="txLimitToAlert"
              formControlName="txLimitToAlert"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.txLimitToAlert.invalid &&
                  (fraudRiskFormControls.txLimitToAlert.dirty ||
                    fraudRiskFormControls.txLimitToAlert.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.txLimitToAlert?.invalid &&
              (fraudRiskFormControls.txLimitToAlert.dirty ||
                fraudRiskFormControls.txLimitToAlert.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.txLimitToAlert?.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.txLimitToAlert?.errors?.max"
            >
              Value is too high. Max is 9999999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="singleForcedTxAmount"
        >
          Single Forced Transaction Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="singleForcedTrAmount">$</span>
            <input
              aria-describedby="singleForcedTrAmount"
              class="form-control"
              type="number"
              name="singleForcedTxAmount"
              id="singleForcedTxAmount"
              formControlName="singleForcedTxAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.singleForcedTxAmount.invalid &&
                  (fraudRiskFormControls.singleForcedTxAmount.dirty ||
                    fraudRiskFormControls.singleForcedTxAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.singleForcedTxAmount?.invalid &&
              (fraudRiskFormControls.singleForcedTxAmount.dirty ||
                fraudRiskFormControls.singleForcedTxAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.singleForcedTxAmount?.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.singleForcedTxAmount?.errors?.max"
            >
              Value is too high. Max is 99999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="aggregateForcedTxAmount"
        >
          Aggregate Forced Transaction Amount
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="aggregateForcedTrAmount">$</span>
            <input
              aria-describedby="aggregateForcedTrAmount"
              class="form-control"
              type="number"
              name="aggregateForcedTxAmount"
              id="aggregateForcedTxAmount"
              formControlName="aggregateForcedTxAmount"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.aggregateForcedTxAmount.invalid &&
                  (fraudRiskFormControls.aggregateForcedTxAmount.dirty ||
                    fraudRiskFormControls.aggregateForcedTxAmount.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.aggregateForcedTxAmount.invalid &&
              (fraudRiskFormControls.aggregateForcedTxAmount.dirty ||
                fraudRiskFormControls.aggregateForcedTxAmount.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.aggregateForcedTxAmount.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.aggregateForcedTxAmount.errors?.max"
            >
              Value is too high. Max is 999999.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label
          class="col-md-4 mt-auto mb-auto control-label text-right"
          for="staleTxDays"
        >
          Stale Transaction Days
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="staleTrDays">$</span>
            <input
              aria-describedby="staleTrDays"
              class="form-control"
              type="number"
              name="staleTxDays"
              id="staleTxDays"
              formControlName="staleTxDays"
              [ngClass]="{
                'is-invalid':
                  fraudRiskFormControls.staleTxDays.invalid &&
                  (fraudRiskFormControls.staleTxDays.dirty ||
                    fraudRiskFormControls.staleTxDays.touched)
              }"
            />
          </div>
          <div
            *ngIf="
              fraudRiskFormControls.staleTxDays.invalid &&
              (fraudRiskFormControls.staleTxDays.dirty ||
                fraudRiskFormControls.staleTxDays.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.staleTxDays.errors?.min"
            >
              Value cannot be less than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="fraudRiskFormControls.staleTxDays.errors?.max"
            >
              Value is too high. Max is 999.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
